import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Step,
  Stepper,
  StepLabel,
} from "@mui/material";

// Project imports
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import { CreatePCAContext } from "./helpers";

const DisplayCurrentFormSection = ({ currentStep }) => {
  switch (currentStep) {
    case 0:
      return <StepOne />;

    case 1:
      return <StepTwo />;

    default:
      break;
  }
};

const steps = ["Search for Corps Member", "Enter Details"];

const CreatePCADialog = ({ isOpen, handleClose }) => {
  const [activeStep, setActiveStep] = useState(0);

  function handleNextStep() {
    setActiveStep(activeStep + 1);
  }

  function handlePreviousStep() {
    setActiveStep(activeStep - 1);
  }

  function handleCloseMiddleWare() {
    handleClose();
    setActiveStep(0);
  }

  const genderSchema = {
    'M': 'Male',
    'F': 'Female',
  }

  const contextObject = {
    handleNextStep,
    handlePreviousStep,
    handleCloseMiddleWare,
    activeStep,
    genderSchema,
  };


  return (
    <CreatePCAContext.Provider value={contextObject}>
      <Dialog
        open={isOpen}
        onClose={handleCloseMiddleWare}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle>Create Post Camp Activity</DialogTitle>

        <DialogContent>
          <Stepper
            activeStep={activeStep}
            sx={{
              mb: "1.5rem",
            }}
          >
            {steps.map((label, index) => {
              return (
                <Step key={index}>
                  <StepLabel> {label} </StepLabel>
                </Step>
              );
            })}
          </Stepper>

          <Divider sx={{ mb: "1rem" }} />

          {/* Current page content */}
          <DisplayCurrentFormSection currentStep={activeStep} />
        </DialogContent>
      </Dialog>
    </CreatePCAContext.Provider>
  );
};

export default CreatePCADialog;
